export default "__VITE_ASSET__DfEWlPw2__"